import type { AccessLevel } from "../types/common";

export const ACCESS_LEVELS: Record<string, AccessLevel> = {
  PUBLIC: 'public',
  AUTHENTICATED: 'authenticated',
  OWN: 'own',
} as const;

